import { jsx as _jsx } from "react/jsx-runtime";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import React from "react";
import styled from "styled-components";
var MAP_DIMENSIONS = {
    BASE_WIDTH: 566,
    BASE_HEIGHT: 281
};
export var MapModule = function() {
    var responsivelyRatio = useResponsiveValue({
        mobileAndAbove: 0,
        tabletAndAbove: 0,
        desktopAndAbove: MIN_WIDTH_BREAKPOINTS.DESKTOP / MIN_WIDTH_BREAKPOINTS.XLARGE,
        xLargeAndAbove: 1
    });
    var width = Math.round(MAP_DIMENSIONS.BASE_WIDTH * responsivelyRatio);
    var height = Math.round(MAP_DIMENSIONS.BASE_HEIGHT * responsivelyRatio);
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(MapWrapper, {
        $width: width,
        $height: height,
        children: /*#__PURE__*/ _jsx(BaseWrapper, {
            children: /*#__PURE__*/ _jsx("img", {
                style: {
                    width: "".concat(width, "px"),
                    height: "".concat(height, "px")
                },
                src: optimizeImageUrl({
                    url: "https://cdn.faire.com/fastly/d1149c5151481631afe208b06cff0f95b92ed4980a3a676a3e20c6dd2cb0cea6.png"
                }, isSSR, {
                    width: width,
                    height: height
                })
            })
        })
    });
};
var MapWrapper = styled.div.withConfig({
    componentId: "sc-5327d8b2-0"
})([
    "position:relative;margin:auto;width:",
    "px;height:",
    "px;"
], function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
});
var BaseWrapper = styled.div.withConfig({
    componentId: "sc-5327d8b2-1"
})([
    "position:absolute;top:0;left:0;z-index:1;"
]);
